import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./outlet-detail.scss";

/* ─── Data helpers ─── */
const makeProduct = (overrides = {}) => ({
  name: "No product yet",
  description: "",
  price: "",
  originalPrice: "",
  prepTime: "",
  image: "",
  dailyQuantity: "",
  dailySold: "0",
  dailyResetTime: "12:00 AM",
  pickupStartTime: "",
  pickupEndTime: "",
  availableStartTime: "",
  availableEndTime: "",
  status: "Draft",
  ...overrides,
});

const makeOutlet = (overrides = {}) => ({
  name: "No outlet yet",
  city: "-",
  state: "Sarawak",
  postcode: "",
  address: "",
  latitude: "",
  longitude: "",
  googleMapUrl: "",
  phone: "",
  platformFee: "1.00",
  platformFeePercent: "5",
  openTime: "",
  closeTime: "",
  lastOrderTime: "",
  acceptingOrders: "No",
  status: "Pending Setup",
  isDraft: false,
  schedule: makeSchedule(),
  product: makeProduct(),
  ...overrides,
});

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const makeSchedule = () =>
  Object.fromEntries(
    DAYS.map((day, i) => [day, { open: i < 5, start: "10:00", end: "20:00" }])
  );

const vendorRecords = {
  "hikari-house": {
    name: "Hikari House",
    contact: "012-3456789",
    city: "Kuching",
    outlets: [
      makeOutlet({
        name: "Kuching Central",
        city: "Kuching",
        postcode: "93300",
        address: "Lot 12, Kuching Central, Jalan Datuk Tawi Sli",
        latitude: "1.5533",
        longitude: "110.3592",
        googleMapUrl: "https://maps.google.com/?q=1.5533,110.3592",
        phone: "012-3456789",
        platformFee: "1.00",
        platformFeePercent: "5",
        openTime: "10:00 AM",
        closeTime: "8:00 PM",
        lastOrderTime: "7:30 PM",
        acceptingOrders: "Yes",
        status: "Accepting Orders",
        schedule: {
          Monday:    { open: true,  start: "10:00", end: "20:00" },
          Tuesday:   { open: true,  start: "10:00", end: "20:00" },
          Wednesday: { open: true,  start: "10:00", end: "20:00" },
          Thursday:  { open: true,  start: "10:00", end: "20:00" },
          Friday:    { open: true,  start: "10:00", end: "21:00" },
          Saturday:  { open: true,  start: "09:00", end: "21:00" },
          Sunday:    { open: false, start: "", end: "" },
        },
        product: makeProduct({
          name: "Chicken Katsu Bento",
          description: "Japanese chicken katsu bento with rice and side dish.",
          price: "12.90",
          originalPrice: "15.90",
          prepTime: "15",
          dailyQuantity: "18",
          dailySold: "7",
          pickupStartTime: "5:30 PM",
          pickupEndTime: "7:30 PM",
          availableStartTime: "10:00 AM",
          availableEndTime: "5:00 PM",
          status: "Available",
          image: "https://images.unsplash.com/photo-1553163147-622ab57be1c7?w=800&q=80",
        }),
      }),
      makeOutlet({
        name: "Vivacity Megamall",
        city: "Kuching",
        postcode: "93350",
        address: "Level 2, Vivacity Megamall",
        latitude: "1.5261",
        longitude: "110.3698",
        googleMapUrl: "https://maps.google.com/?q=1.5261,110.3698",
        phone: "012-3456799",
        platformFee: "1.20",
        platformFeePercent: "6",
        openTime: "11:00 AM",
        closeTime: "8:30 PM",
        lastOrderTime: "8:00 PM",
        acceptingOrders: "Yes",
        status: "Accepting Orders",
        product: makeProduct({
          name: "Teriyaki Rice Box",
          description: "Teriyaki rice box for Vivacity outlet.",
          price: "13.90",
          prepTime: "15",
          dailyQuantity: "12",
          dailySold: "4",
          pickupStartTime: "5:30 PM",
          pickupEndTime: "7:30 PM",
          availableStartTime: "10:30 AM",
          availableEndTime: "5:30 PM",
          status: "Available",
        }),
      }),
      makeOutlet({
        name: "Samarahan Express",
        city: "Kota Samarahan",
        postcode: "94300",
        address: "Uni Central, Kota Samarahan",
        latitude: "1.4597",
        longitude: "110.4382",
        googleMapUrl: "https://maps.google.com/?q=1.4597,110.4382",
        phone: "012-3456700",
        platformFee: "1.00",
        platformFeePercent: "5",
        openTime: "10:00 AM",
        closeTime: "8:00 PM",
        lastOrderTime: "7:30 PM",
        acceptingOrders: "Yes",
        status: "Accepting Orders",
        product: makeProduct({
          name: "Salmon Rice Box",
          description: "Salmon rice box for Samarahan outlet.",
          price: "15.90",
          prepTime: "18",
          dailyQuantity: "10",
          dailySold: "0",
          pickupStartTime: "5:30 PM",
          pickupEndTime: "7:30 PM",
          availableStartTime: "10:00 AM",
          availableEndTime: "5:00 PM",
          status: "Available",
        }),
      }),
    ],
  },
  "green-bowl": {
    name: "Green Bowl",
    contact: "011-2233445",
    city: "Kuching",
    outlets: [
      makeOutlet({ name: "Padungan", city: "Kuching", address: "Jalan Padungan", phone: "011-2233445", openTime: "10:30 AM", closeTime: "7:00 PM", lastOrderTime: "6:30 PM", acceptingOrders: "Yes", status: "Accepting Orders", product: makeProduct({ name: "Healthy Bowl", price: "11.50", dailyQuantity: "15", dailySold: "5", status: "Available" }) }),
      makeOutlet({ name: "Batu Kawa", city: "Kuching", address: "Emart Batu Kawa", phone: "011-2233446", openTime: "10:30 AM", closeTime: "7:00 PM", lastOrderTime: "6:30 PM", acceptingOrders: "Yes", status: "Accepting Orders", product: makeProduct({ name: "Protein Salad", price: "12.50", dailyQuantity: "12", dailySold: "3", status: "Available" }) }),
    ],
  },
  "daily-bakery": {
    name: "Daily Bakery",
    contact: "016-9988776",
    city: "Miri",
    outlets: [makeOutlet({ name: "Miri Times Square", city: "Miri", address: "Ground Floor, Miri Times Square", phone: "016-9988776", acceptingOrders: "No", status: "Pending Setup", product: makeProduct({ name: "Sourdough Set", price: "9.90", dailyQuantity: "0", dailySold: "0", status: "Draft" }) })],
  },
  "urban-cafe": {
    name: "Urban Cafe",
    contact: "019-7788990",
    city: "Sibu",
    outlets: [makeOutlet({ name: "Sibu Central", city: "Sibu", address: "No. 18, Sibu Central", phone: "019-7788990", acceptingOrders: "No", status: "Inactive", product: makeProduct({ name: "Matcha Latte", price: "9.90", dailyQuantity: "0", dailySold: "0", status: "Hidden" }) })],
  },
};

/* ─── Utils ─── */
const statusClass = (v) => String(v).toLowerCase().replace(/\s+/g, "-");
const timeToInput = (value) => {
  if (!value) return "";
  const match = String(value).trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i);
  if (!match) return value;
  let hour = Number(match[1]);
  const minute = match[2];
  const period = match[3]?.toUpperCase();
  if (period === "PM" && hour < 12) hour += 12;
  if (period === "AM" && hour === 12) hour = 0;
  return `${String(hour).padStart(2, "0")}:${minute}`;
};
const inputToTime = (value) => {
  if (!value) return "";
  const [hourText, minute] = value.split(":");
  let hour = Number(hourText);
  const period = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${period}`;
};

const INVENTORY_RULES = {
  reduceQuantityOn: ["On Hold", "Paid"],
  restoreQuantityOn: ["Cancelled", "Payment Timeout"],
};

/* ─── Shared field components ─── */
const Field = ({ label, children, hint, className = "" }) => (
  <label className={`outlet-detail__field${className ? ` ${className}` : ""}`}>
    <span>{label}</span>
    {children}
    {hint && <small>{hint}</small>}
  </label>
);

const TextField = ({ label, value, onChange, placeholder, type = "text", readOnly = false, hint, className = "" }) => (
  <Field label={label} hint={hint} className={`${readOnly ? "outlet-detail__field--readonly" : ""}${className ? ` ${className}` : ""}`}>
    <input type={type} value={value || ""} placeholder={placeholder} readOnly={readOnly}
      onChange={(e) => !readOnly && onChange?.(e.target.value)} />
  </Field>
);

const SelectField = ({ label, value, onChange, options, readOnly = false, className = "" }) => (
  <Field label={label} className={`${readOnly ? "outlet-detail__field--readonly" : ""}${className ? ` ${className}` : ""}`}>
    <select value={value} disabled={readOnly} onChange={(e) => !readOnly && onChange?.(e.target.value)}>
      {options.map((o) => <option key={o}>{o}</option>)}
    </select>
  </Field>
);

const TimeField = ({ label, value, onChange, readOnly = false, hint, className = "" }) => (
  <Field label={label} hint={hint} className={`${readOnly ? "outlet-detail__field--readonly" : ""}${className ? ` ${className}` : ""}`}>
    <input type="time" value={timeToInput(value)} readOnly={readOnly}
      onChange={(e) => !readOnly && onChange?.(inputToTime(e.target.value))} />
  </Field>
);

const TimeRange = ({ startLabel, endLabel, startVal, endVal, onStartChange, onEndChange, readOnly = false, hint }) => (
  <div className="outlet-detail__field">
    <span>{startLabel} — {endLabel}</span>
    <div className="outlet-detail__time-range">
      <input type="time" value={timeToInput(startVal)} readOnly={readOnly}
        onChange={(e) => !readOnly && onStartChange?.(inputToTime(e.target.value))}
        className={`outlet-detail__time-input${readOnly ? " outlet-detail__time-input--readonly" : ""}`} />
      <span className="outlet-detail__time-sep">–</span>
      <input type="time" value={timeToInput(endVal)} readOnly={readOnly}
        onChange={(e) => !readOnly && onEndChange?.(inputToTime(e.target.value))}
        className={`outlet-detail__time-input${readOnly ? " outlet-detail__time-input--readonly" : ""}`} />
    </div>
    {hint && <small>{hint}</small>}
  </div>
);

const ProductImage = ({ value, onZoom }) => {
  const hasImage = value && String(value).trim() !== "";
  if (!hasImage) {
    return (
      <div className="outlet-detail__image-empty">
        <i className="ti ti-photo-off" aria-hidden="true"></i>
        <span>No product image uploaded yet</span>
      </div>
    );
  }
  return (
    <button type="button" className="outlet-detail__image-thumb" onClick={() => onZoom(value)}>
      <img src={value} alt="Product" />
      <span className="outlet-detail__image-zoom">
        <i className="ti ti-zoom-in" aria-hidden="true"></i>
        View
      </span>
    </button>
  );
};

const Lightbox = ({ src, onClose }) => {
  if (!src) return null;
  return (
    <div className="outlet-detail__lightbox" onClick={onClose} role="dialog" aria-modal="true" aria-label="Product image preview">
      <button type="button" className="outlet-detail__lightbox-close" onClick={onClose} aria-label="Close preview">
        <i className="ti ti-x" aria-hidden="true"></i>
      </button>
      <img src={src} alt="Product enlarged" onClick={(e) => e.stopPropagation()} />
    </div>
  );
};

const ConfirmDialog = ({ open, title, message, confirmLabel = "Confirm", tone = "danger", onConfirm, onCancel }) => {
  if (!open) return null;
  return (
    <div className="outlet-detail__modal-overlay" onClick={onCancel} role="dialog" aria-modal="true" aria-label={title}>
      <div className="outlet-detail__modal" onClick={(e) => e.stopPropagation()}>
        <div className={`outlet-detail__modal-icon outlet-detail__modal-icon--${tone}`}>
          <i className="ti ti-trash" aria-hidden="true"></i>
        </div>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="outlet-detail__modal-actions">
          <button type="button" className="outlet-detail__modal-cancel" onClick={onCancel}>Cancel</button>
          <button type="button" className={`outlet-detail__modal-confirm outlet-detail__modal-confirm--${tone}`} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ─── Page ─── */
const OutletDetailPage = ({ mode = "view" }) => {
  const navigate = useNavigate();
  const { vendorId, outletId } = useParams();
  const vendor = useMemo(() => vendorRecords[vendorId] || vendorRecords["hikari-house"], [vendorId]);
  const initialIndex = Math.max(Number(outletId || 1) - 1, 0);
  const [outlets, setOutlets] = useState(
    vendor.outlets?.length ? vendor.outlets : [makeOutlet({ phone: vendor.contact, city: vendor.city })]
  );
  const [selectedIndex, setSelectedIndex] = useState(initialIndex);
  const [activeTab, setActiveTab] = useState(mode === "create" ? "outlet" : "product");
  const [message, setMessage] = useState("");
  const [lightboxSrc, setLightboxSrc] = useState(null);
  const [pendingRemove, setPendingRemove] = useState(null);

  const outlet = outlets[selectedIndex] || outlets[0] || makeOutlet();
  const product = outlet.product || makeProduct();
  const schedule = outlet.schedule || makeSchedule();

  const sold = Number(product.dailySold || 0);
  const daily = Number(product.dailyQuantity || 0);
  const remaining = Math.max(daily - sold, 0);
  const soldPct = daily > 0 ? Math.round((sold / daily) * 100) : 0;

  const feeExampleSubtotal = Number(product.price || 0) > 0 ? Number(product.price) : 25;
  const feeExamplePercent = feeExampleSubtotal * (Number(outlet.platformFeePercent || 0) / 100);
  const feeExampleCharged = Math.max(feeExamplePercent, Number(outlet.platformFee || 0));

  const updateOutlet = (field, value) =>
    setOutlets((curr) => curr.map((o, i) => i === selectedIndex ? { ...o, [field]: value } : o));

  const updateProduct = (field, value) =>
    setOutlets((curr) => curr.map((o, i) =>
      i === selectedIndex ? { ...o, product: { ...(o.product || makeProduct()), [field]: value } } : o
    ));

  const updateScheduleDay = (day, field, value) =>
    setOutlets((curr) => curr.map((o, i) =>
      i === selectedIndex ? {
        ...o,
        schedule: { ...(o.schedule || makeSchedule()), [day]: { ...(o.schedule?.[day] || {}), [field]: value } }
      } : o
    ));

  const addOutlet = () => {
    setOutlets((curr) => [...curr, makeOutlet({ name: "New Outlet", phone: vendor.contact, city: vendor.city || "Kuching", isDraft: true })]);
    setSelectedIndex(outlets.length);
    setActiveTab("outlet");
    setMessage("New outlet added. Fill in the outlet setup and save.");
  };

  const requestRemoveOutlet = (index) => {
    if (outlets.length <= 1) {
      setMessage("Each vendor needs at least one outlet. This outlet can't be removed.");
      setTimeout(() => setMessage(""), 3500);
      return;
    }
    setPendingRemove(index);
  };

  const confirmRemoveOutlet = () => {
    const index = pendingRemove;
    if (index == null) return;
    const removedName = outlets[index]?.name || "Outlet";
    setOutlets((curr) => {
      const next = curr.filter((_, i) => i !== index);
      return next.length ? next : curr;
    });
    setSelectedIndex((curr) => {
      if (index < curr) return curr - 1;
      if (index === curr) return Math.max(0, index - 1);
      return curr;
    });
    setActiveTab("product");
    setPendingRemove(null);
    setMessage(`${removedName} removed.`);
    setTimeout(() => setMessage(""), 3000);
  };

  const save = (type) => {
    if (type === "outlet") {
      setOutlets((curr) => curr.map((o, i) => i === selectedIndex ? { ...o, isDraft: false } : o));
    }
    setMessage(
      type === "product" ? "Product saved." :
      type === "hours"   ? "Operating hours saved." :
      "Outlet setup saved."
    );
    setTimeout(() => setMessage(""), 3000);
  };

  return (
    <div className="outlet-detail">
      {/* Notice */}
      {message && (
        <div className="outlet-detail__notice-wrap">
          <div className="outlet-detail__notice">
            <i className="ti ti-circle-check" aria-hidden="true"></i>
            <span>{message}</span>
            <button type="button" onClick={() => setMessage("")} aria-label="Dismiss">
              <i className="ti ti-x" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      )}

      {/* Page header */}
      <header className="outlet-detail__header">
        <div className="outlet-detail__header-left">
          <button className="outlet-detail__back" type="button"
            onClick={() => navigate(`/admin/vendors/${vendorId}`)}>
            ← Back to vendor
          </button>
          <div>
            <p className="outlet-detail__eyebrow">SecondBite Admin</p>
            <h2 className="outlet-detail__header-title">{outlet.name}</h2>
            <p className="outlet-detail__header-sub">{vendor.name} · Outlet details, product setup, and operating hours</p>
          </div>
        </div>
        <div className="outlet-detail__header-actions">
          <span className={`outlet-detail__status outlet-detail__status--${statusClass(outlet.status)}`}>
            {outlet.status}
          </span>
          <button className="outlet-detail__footer-save" type="button" onClick={addOutlet}>
            + Add outlet
          </button>
        </div>
      </header>

      {/* Context strip */}
      <div className="outlet-detail__context">
        <div className="outlet-detail__ctx">
          <div className="outlet-detail__ctx-label">Vendor</div>
          <div className="outlet-detail__ctx-val">{vendor.name}</div>
          <div className="outlet-detail__ctx-sub">{outlets.length} active outlets</div>
        </div>
        <div className="outlet-detail__ctx">
          <div className="outlet-detail__ctx-label">Product</div>
          <div className="outlet-detail__ctx-val">{product.name}</div>
          <div className="outlet-detail__ctx-sub">RM{product.price || "—"} · {product.dailyQuantity || "—"} daily</div>
        </div>
        <div className="outlet-detail__ctx">
          <div className="outlet-detail__ctx-label">Sold today</div>
          <div className="outlet-detail__ctx-val">
            {sold} <span>of {daily || "—"}</span>
          </div>
          <div className="outlet-detail__progress">
            <div className="outlet-detail__progress-fill" style={{ width: `${soldPct}%` }} />
          </div>
          <div className="outlet-detail__ctx-sub">{soldPct}% · {remaining} remaining</div>
        </div>
        <div className="outlet-detail__ctx">
          <div className="outlet-detail__ctx-label">Pickup window</div>
          <div className="outlet-detail__ctx-val">
            {product.pickupStartTime && product.pickupEndTime
              ? `${product.pickupStartTime} – ${product.pickupEndTime}`
              : "—"}
          </div>
          <div className="outlet-detail__ctx-sub">Last order: {outlet.lastOrderTime || "—"}</div>
        </div>
      </div>

      {/* Workspace */}
      <div className="outlet-detail__workspace">
        {/* Outlet sidebar */}
        <aside className="outlet-detail__sidebar-card">
          <div className="outlet-detail__side-title">
            <div>
              <span>Outlets</span>
              <strong>{outlets.length} outlet{outlets.length !== 1 ? "s" : ""}</strong>
            </div>
            <button type="button" onClick={addOutlet}>+ Add</button>
          </div>
          <div className="outlet-detail__outlet-list">
            {outlets.map((o, idx) => (
              <div
                key={`${o.name}-${idx}`}
                className={`outlet-detail__outlet-card${selectedIndex === idx ? " outlet-detail__outlet-card--active" : ""}`}
                onClick={() => { setSelectedIndex(idx); setActiveTab(o.isDraft ? "outlet" : "product"); }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { setSelectedIndex(idx); setActiveTab(o.isDraft ? "outlet" : "product"); } }}
              >
                <div className="outlet-detail__outlet-card-head">
                  <span>Outlet {idx + 1}</span>
                  {outlets.length > 1 && (
                    <button
                      type="button"
                      className="outlet-detail__outlet-remove"
                      aria-label={`Remove outlet ${o.name}`}
                      title="Remove outlet"
                      onClick={(e) => { e.stopPropagation(); requestRemoveOutlet(idx); }}
                    >
                      <i className="ti ti-trash" aria-hidden="true"></i>
                    </button>
                  )}
                </div>
                <strong>{o.name}</strong>
                <small>{o.product?.name || "No product yet"}</small>
                <em className={`outlet-detail__mini-status outlet-detail__mini-status--${statusClass(o.status)}`}>
                  {o.acceptingOrders === "Yes" ? "Accepting orders" : o.status}
                </em>
              </div>
            ))}
          </div>
        </aside>

        {/* Main content */}
        <main className="outlet-detail__main-card">
          <div className="outlet-detail__card">
            {/* Tabs */}
            <div className="outlet-detail__tabs">
              {[["outlet", "Outlet setup"], ["product", "Product"], ["hours", "Operating hours"]].map(([key, label]) => (
                <button key={key} type="button"
                  className={activeTab === key ? "active" : ""}
                  onClick={() => setActiveTab(key)}>
                  {label}
                </button>
              ))}
            </div>

            {/* ── OUTLET SETUP ── */}
            {activeTab === "outlet" && (
              <section className="outlet-detail__section">
                <div className="outlet-detail__section-head">
                  <div>
                    <h3>Outlet setup</h3>
                    <p>Operational details. Business and bank info is managed by admin.</p>
                  </div>
                  <button type="button" onClick={() => save("outlet")}>Save outlet</button>
                </div>

                <div className="outlet-detail__form-body">
                  <div className="outlet-detail__group">
                    <div className="outlet-detail__group-label">Identity</div>
                    <div className="outlet-detail__grid-2">
                      <TextField label="Outlet name (managed by admin)" value={outlet.name} onChange={(v) => updateOutlet("name", v)} placeholder="Kuching Central" />
                      <TextField label="Business phone" value={outlet.phone} onChange={(v) => updateOutlet("phone", v)} placeholder="012-3456789" />
                    </div>
                  </div>

                  <hr className="outlet-detail__divider" />

                  <div className="outlet-detail__group">
                    <div className="outlet-detail__group-label">Platform fee</div>
                    <div className="outlet-detail__grid-2">
                      <TextField label="Base fee (RM)" value={outlet.platformFee} type="number"
                        onChange={(v) => updateOutlet("platformFee", v)} placeholder="1.00" />
                      <TextField label="Percentage fee (%)" value={outlet.platformFeePercent} type="number"
                        onChange={(v) => updateOutlet("platformFeePercent", v)} placeholder="5" />
                    </div>
                    <div className="outlet-detail__fee-note">
                      <i className="ti ti-info-circle" aria-hidden="true"></i>
                      <div>
                        <strong>Whichever is higher is charged.</strong>
                        <span>
                          The platform fee is the greater of the base fee (RM{Number(outlet.platformFee || 0).toFixed(2)})
                          {" "}or {Number(outlet.platformFeePercent || 0)}% of the order subtotal.
                          {" "}Example: on a RM{feeExampleSubtotal.toFixed(2)} order, the percentage fee is
                          {" "}RM{feeExamplePercent.toFixed(2)} and the base fee is RM{Number(outlet.platformFee || 0).toFixed(2)},
                          {" "}so RM{feeExampleCharged.toFixed(2)} is charged.
                        </span>
                      </div>
                    </div>
                  </div>

                  <hr className="outlet-detail__divider" />

                  <div className="outlet-detail__group">
                    <div className="outlet-detail__group-label">Location</div>
                    <div style={{ marginBottom: 14 }}>
                      <TextField label="Street address" value={outlet.address}
                        onChange={(v) => updateOutlet("address", v)} placeholder="Outlet address" />
                    </div>
                    <div className="outlet-detail__grid-3" style={{ marginBottom: 14 }}>
                      <TextField label="City" value={outlet.city} onChange={(v) => updateOutlet("city", v)} placeholder="Kuching" />
                      <TextField label="State" value={outlet.state} onChange={(v) => updateOutlet("state", v)} placeholder="Sarawak" />
                      <TextField label="Postcode" value={outlet.postcode} onChange={(v) => updateOutlet("postcode", v)} placeholder="93300" />
                    </div>
                    <div className="outlet-detail__grid-2" style={{ marginBottom: 14 }}>
                      <TextField label="Latitude" value={outlet.latitude} onChange={(v) => updateOutlet("latitude", v)} placeholder="1.5533" />
                      <TextField label="Longitude" value={outlet.longitude} onChange={(v) => updateOutlet("longitude", v)} placeholder="110.3592" />
                    </div>
                    <TextField label="Google Maps URL" value={outlet.googleMapUrl}
                      onChange={(v) => updateOutlet("googleMapUrl", v)} placeholder="https://maps.google.com/?q=..." />
                  </div>

                  <hr className="outlet-detail__divider" />

                  <div className="outlet-detail__group">
                    <div className="outlet-detail__group-label">Status</div>
                    <div className="outlet-detail__grid-2">
                      <SelectField label="Accepting orders" value={outlet.acceptingOrders}
                        onChange={(v) => updateOutlet("acceptingOrders", v)} options={["Yes", "No"]} />
                      <SelectField label="Outlet status" value={outlet.status}
                        onChange={(v) => updateOutlet("status", v)}
                        options={["Accepting Orders", "Pending Setup", "Inactive"]} />
                    </div>
                  </div>
                </div>

                <div className="outlet-detail__footer">
                  {outlets.length > 1 && (
                    <button
                      className="outlet-detail__footer-danger"
                      type="button"
                      onClick={() => requestRemoveOutlet(selectedIndex)}
                    >
                      <i className="ti ti-trash" aria-hidden="true"></i>
                      Remove outlet
                    </button>
                  )}
                  <div className="outlet-detail__footer-right">
                    <button className="outlet-detail__footer-ghost" type="button">Discard</button>
                    <button className="outlet-detail__footer-save" type="button" onClick={() => save("outlet")}>Save outlet</button>
                  </div>
                </div>
              </section>
            )}

            {/* ── PRODUCT ── */}
            {activeTab === "product" && (
              <section className="outlet-detail__section">
                {/* Live stats */}
                <div className="outlet-detail__stats">
                  <div className="outlet-detail__stat">
                    <div className="outlet-detail__ctx-label">Sold today</div>
                    <div className="outlet-detail__stat-val">{sold} <span>/ {daily || "—"}</span></div>
                    <div className="outlet-detail__progress" style={{ marginTop: 6 }}>
                      <div className="outlet-detail__progress-fill" style={{ width: `${soldPct}%` }} />
                    </div>
                    <div className="outlet-detail__ctx-sub">{soldPct}% of daily quantity</div>
                  </div>
                  <div className="outlet-detail__stat">
                    <div className="outlet-detail__ctx-label">Remaining</div>
                    <div className="outlet-detail__stat-val">{remaining}</div>
                    <div className="outlet-detail__progress" style={{ marginTop: 6 }}>
                      <div className="outlet-detail__progress-fill" style={{ width: daily > 0 ? `${100 - soldPct}%` : "0%" }} />
                    </div>
                    <div className="outlet-detail__ctx-sub">Resets at {product.dailyResetTime || "12:00 AM"}</div>
                  </div>
                  <div className="outlet-detail__stat">
                    <div className="outlet-detail__ctx-label">Prep time</div>
                    <div className="outlet-detail__stat-val">{product.prepTime || "—"} <span>min</span></div>
                    <div className="outlet-detail__ctx-sub">Per order</div>
                  </div>
                </div>

                <div className="outlet-detail__section-head">
                  <div>
                    <h3>Product — {product.name}</h3>
                    <p>Read-only in admin portal. Managed in the vendor portal.</p>
                  </div>
                  <span className="outlet-detail__readonly-badge">Read only</span>
                </div>

                <div className="outlet-detail__form-body">
                  <div className="outlet-detail__group">
                    <div className="outlet-detail__group-label">Product details</div>
                    <div style={{ marginBottom: 14 }}>
                      <TextField label="Product name" value={product.name} readOnly />
                    </div>
                    <div className="outlet-detail__grid-3" style={{ marginBottom: 14 }}>
                      <TextField label="Price (RM)" value={product.price} readOnly />
                      <TextField label="Original price (optional)" value={product.originalPrice} readOnly />
                      <TextField label="Preparation time (min)" value={product.prepTime} readOnly />
                    </div>
                    <div>
                      <Field label="Description" className="outlet-detail__field--readonly">
                        <textarea value={product.description} readOnly />
                      </Field>
                    </div>
                  </div>

                  <hr className="outlet-detail__divider" />

                  <div className="outlet-detail__group">
                    <div className="outlet-detail__group-label">Inventory</div>
                    <div className="outlet-detail__grid-3" style={{ marginBottom: 14 }}>
                      <TextField label="Daily quantity" value={product.dailyQuantity} readOnly />
                      <TimeField label="Quantity reset time" value={product.dailyResetTime} readOnly />
                      <SelectField label="Status" value={product.status} options={["Available", "Sold Out", "Hidden", "Draft"]} readOnly />
                    </div>
                    <div className="outlet-detail__rule-card">
                      <span>Inventory rules — program controlled</span>
                      <small>Quantity resets automatically at the configured reset time</small>
                      <small>Quantity reduces on {INVENTORY_RULES.reduceQuantityOn.join(" and ")}</small>
                      <small>Quantity restores on {INVENTORY_RULES.restoreQuantityOn.join(" and ")}</small>
                    </div>
                  </div>

                  <hr className="outlet-detail__divider" />

                  <div className="outlet-detail__group">
                    <div className="outlet-detail__group-label">Pickup window</div>
                    <div className="outlet-detail__grid-2" style={{ marginBottom: 0 }}>
                      <TimeRange
                        startLabel="Pickup start" endLabel="end"
                        startVal={product.pickupStartTime} endVal={product.pickupEndTime}
                        readOnly
                        hint="Customers can pick up purchased items within this window."
                      />
                      <TimeRange
                        startLabel="Available start" endLabel="end"
                        startVal={product.availableStartTime} endVal={product.availableEndTime}
                        readOnly
                        hint="Customers can purchase this item within this window."
                      />
                    </div>
                  </div>

                  <hr className="outlet-detail__divider" />

                  <div className="outlet-detail__group">
                    <div className="outlet-detail__group-label">Product image</div>
                    <ProductImage value={product.imagePreview || product.image} onZoom={setLightboxSrc} />
                  </div>
                </div>
              </section>
            )}

            {/* ── OPERATING HOURS ── */}
            {activeTab === "hours" && (
              <section className="outlet-detail__section">
                <div className="outlet-detail__section-head">
                  <div>
                    <h3>Operating hours</h3>
                    <p>Weekly schedule for this outlet.</p>
                  </div>
                  <button type="button" onClick={() => save("hours")}>Save hours</button>
                </div>

                <div className="outlet-detail__form-body">
                  <div className="outlet-detail__group">
                    <div className="outlet-detail__group-label">Weekly schedule</div>
                    <div className="outlet-detail__schedule">
                      {DAYS.map((day) => {
                        const d = schedule[day] || { open: false, start: "", end: "" };
                        return (
                          <div key={day} className="outlet-detail__day-row">
                            <span className={`outlet-detail__day-name${!d.open ? " outlet-detail__day-name--closed" : ""}`}>
                              {day}
                            </span>
                            <label className="outlet-detail__day-toggle">
                              <input
                                type="checkbox"
                                checked={!!d.open}
                                onChange={(e) => updateScheduleDay(day, "open", e.target.checked)}
                              />
                              Open
                            </label>
                            {d.open ? (
                              <div className="outlet-detail__time-range">
                                <input
                                  type="time"
                                  value={d.start || ""}
                                  onChange={(e) => updateScheduleDay(day, "start", e.target.value)}
                                  className="outlet-detail__time-input"
                                />
                                <span className="outlet-detail__time-sep">–</span>
                                <input
                                  type="time"
                                  value={d.end || ""}
                                  onChange={(e) => updateScheduleDay(day, "end", e.target.value)}
                                  className="outlet-detail__time-input"
                                />
                              </div>
                            ) : (
                              <span className="outlet-detail__day-closed-label">Closed</span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="outlet-detail__footer">
                  <button className="outlet-detail__footer-ghost" type="button">Discard</button>
                  <button className="outlet-detail__footer-save" type="button" onClick={() => save("hours")}>Save hours</button>
                </div>
              </section>
            )}
          </div>
        </main>
      </div>

      <Lightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />

      <ConfirmDialog
        open={pendingRemove != null}
        title="Remove this outlet?"
        message={
          pendingRemove != null
            ? `Removing "${outlets[pendingRemove]?.name}" permanently deletes its outlet setup, product, and operating hours. This can't be undone.`
            : ""
        }
        confirmLabel="Remove outlet"
        tone="danger"
        onConfirm={confirmRemoveOutlet}
        onCancel={() => setPendingRemove(null)}
      />
    </div>
  );
};

export default OutletDetailPage;
